import { Box, Icon, useModalState } from '@bechtel/gds';
import { FilterGroupInput } from '@bechtel/sr-types';
import { isEmpty } from 'lodash';
import { IconButtonStyled, MultiLingualText } from '~/components/atoms';
import { FilterModal, getFilterString } from '../grid/filter-modal';
import { SectionHeaderStyled, TextAreaStyled } from './styled';

export const Filter = ({
  title = 'Filter',
  entityName,
  value,
  handleFilter,
  disabled,
}: {
  title?: string;
  entityName: string;
  value: string;
  handleFilter: (value: string) => void;
  disabled?: boolean;
}) => {
  const { visible, open, close } = useModalState(false);
  const cellValue = isEmpty(value) ? '' : getFilterString(JSON.parse(value));
  const filterGroup: FilterGroupInput = value ? JSON.parse(value) : {};

  return (
    <Box flexGrow={{ sm: '1' }} flexDirection={{ sm: 'column' }}>
      <SectionHeaderStyled>
        <MultiLingualText size="400" weight="600" color="grey.800">
          {title}
        </MultiLingualText>
        <Box
          ml={{ sm: '400' }}
          css={{ cursor: disabled ? 'default' : 'pointer' }}
          onClick={() => {
            if (disabled) return;
            open();
          }}
        >
          <IconButtonStyled disabled={disabled}>
            <Icon icon="filter" iconStyle="regular" fillColor="primary.500" />
          </IconButtonStyled>
        </Box>
      </SectionHeaderStyled>
      <TextAreaStyled value={cellValue} rows={5} readOnly />
      {visible && (
        <FilterModal
          close={close}
          visible={visible}
          entityName={entityName}
          initialFilter={filterGroup}
          onApplyFilter={(value) => {
            handleFilter(JSON.stringify(value));
          }}
        />
      )}
    </Box>
  );
};
